module.exports = __webpack_public_path__ + "static/daivik-resume-b5effb2dc5ba1081d6e81212b697c8e6.pdf";